import React from 'react';
import { BellIcon, MessageCircleIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import FeedItem from '../components/feed/FeedItem';
import StorySection from '../components/feed/StorySection';
const HomePage = () => {
  const feedPosts = [{
    id: '1',
    user: {
      name: 'Kylian Mbappé',
      username: 'k.mbappe',
      avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d',
      verified: true,
      role: 'Player',
      sport: 'football'
    },
    content: {
      type: 'image',
      media: ['https://images.unsplash.com/photo-1517466787929-bc90951d0974'],
      caption: 'Great training session today with the team! #PreSeason',
      location: 'Madrid, Spain',
      tags: ['#RealMadrid', '#Training', '#Football']
    },
    stats: {
      likes: 245789,
      comments: 3421,
      timestamp: '2 hours ago'
    },
    relationship: {
      type: 'Forward',
      entity: 'Real Madrid'
    }
  }, {
    id: '2',
    user: {
      name: 'FC Barcelona',
      username: 'fcbarcelona',
      avatar: 'https://images.unsplash.com/photo-1522778119026-d647f0596c20',
      verified: true,
      role: 'Club',
      sport: 'football'
    },
    content: {
      type: 'carousel',
      media: ['https://images.unsplash.com/photo-1489944440615-453fc2b6a9a9', 'https://images.unsplash.com/photo-1518604666860-9ed391f76460'],
      caption: 'New signing announcement! Welcome to the club! 🔵🔴',
      tags: ['#Transfer', '#NewSigning', '#FCBarcelona']
    },
    stats: {
      likes: 542331,
      comments: 8976,
      timestamp: '5 hours ago'
    }
  }];
  return <div className="bg-white min-h-full" data-id="element-776">
      {/* Header */}
      <div className="flex justify-between items-center px-4 py-3 border-b border-gray-100 bg-white sticky top-0 z-10" data-id="element-777">
        <h1 className="text-2xl font-bold text-green-600" data-id="element-778">SportProz</h1>
        <div className="flex space-x-4" data-id="element-779">
          <Link to="/chat" className="text-gray-700 hover:text-green-600 transition-colors" data-id="element-780">
            <MessageCircleIcon size={24} data-id="element-781" />
          </Link>
          <Link to="/notifications" className="text-gray-700 hover:text-green-600 transition-colors relative" data-id="element-782">
            <BellIcon size={24} data-id="element-783" />
            <span className="absolute -top-1 -right-1 bg-orange-500 text-white text-xs w-4 h-4 rounded-full flex items-center justify-center" data-id="element-784">
              3
            </span>
          </Link>
        </div>
      </div>
      {/* Stories */}
      <StorySection data-id="element-785" />
      {/* Feed */}
      <div className="pb-16" data-id="element-786">
        {feedPosts.map(post => <FeedItem key={post.id} post={post} data-id="element-787" />)}
      </div>
    </div>;
};
export default HomePage;